import { makeApi } from 'src/http/api/internal/internal-http';
import { ConfigurationsRepository } from 'src/repositories/configurations/configurations.repository';
import { configurationItemType } from 'src/types/configurations';
import { create } from 'zustand';

type Actions = {
  getAll: () => Promise<void>;
  update: (name: string, value: any) => Promise<void>;
};

type State = {
  loadingPage: boolean;
  loadingUpdate: boolean;
  configList: configurationItemType[]
};

type CreditStore = Actions & State;

const repository = new ConfigurationsRepository(makeApi());

const initialState: State = {
  loadingPage: false,
  loadingUpdate: false,
  configList: []
};

export const useConfigurationsStore = create<CreditStore>((set) => ({
  ...initialState,

  getAll: async () => {
    set({ loadingPage: true });
    const response = await repository.getAll();
    if (response.isLeft()) {
      set({ loadingPage: false });
      return;
    }
    set({ loadingPage: false, configList: response.value });
  },

  update: async (name: string, value: any) => {
    set({ loadingUpdate: true });
    const response = await repository.update(name, value);
    set({ loadingUpdate: false });
    if (response.isLeft()) {
      throw response.value;
    }
  },

}));
